import { DATE_FORMAT } from '@dev-spendesk/grapes';
import React from 'react';

import { useTranslation } from 'common/hooks/useTranslation';
import { BudgetGauge } from 'modules/budgets/components/BudgetGauge';
import { BudgetAmountEstimation } from 'modules/budgets/components/BudgetOverview';
import { BudgetOverviewHeader } from 'modules/budgets/components/BudgetOverview/BudgetOverviewHeader';
import { type Trip } from 'modules/requests/hooks/useCurrentTripsQuery';

type Props = {
  trip: Omit<Trip, 'status'>;
  showHeader?: boolean;
};

export const TripBudget = ({ trip, showHeader }: Props) => {
  const { t, localeFormat } = useTranslation('global');

  if (!trip.budget?.state) {
    return null;
  }

  return (
    <div className="rounded-8 border-border-default bg-background-primary-default flex flex-col items-start gap-16 border border-solid p-16 leading-6 shadow-xs">
      {showHeader ? (
        <BudgetOverviewHeader
          name={`${trip.name ?? '-'} (${localeFormat(new Date(trip.startDate), DATE_FORMAT.SHORT)} - ${localeFormat(new Date(trip.endDate), DATE_FORMAT.SHORT)})`}
          mode="compact"
          amount={trip.budget.state.budgeted}
          breakdown={trip.budget.state}
        />
      ) : (
        <BudgetAmountEstimation
          amount={trip.budget.state.budgeted}
          breakdown={trip.budget.state}
          hint={t('requests.panel.travelBudget.includedHint')}
        />
      )}
      {(trip.budget.state.used.amount > 0 ||
        trip.budget.state.committed.amount > 0) && (
        <BudgetGauge
          budgetBreakdown={trip.budget.state}
          gaugeConfiguration={{
            tooltip: {
              mode: 'compact',
            },
          }}
        />
      )}
    </div>
  );
};
